// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"381":"eb9584ea","760":"ebc60fff"}[chunkId] + ".chunk.css";
};